import { render, staticRenderFns } from "./MultiSelectOrderType.vue?vue&type=template&id=062f4943&"
import script from "./MultiSelectOrderType.vue?vue&type=script&lang=js&"
export * from "./MultiSelectOrderType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports